import css from "./style.scss";
import cx from "classnames";
import { Text } from "preact-i18n";
import CryptoList from "../crypto-list";

const PaymentMethod = () => (
  <div class={cx(css.wrapper)}>
    <div class={cx(css.header, "text-center")}>
      <Text id="payment.select-payment">Select payment method</Text>
    </div>
    <CryptoList />
  </div>
);

export default PaymentMethod;
